import { Card } from "../Common/Card";
import Layout from "../Common/Layout";
import Spacer from "../Common/Spacer";

const Homepage = () => {
  return (
    <Spacer mt="2em">
      <Card variant="secondary">
        <Spacer margin="1em" style={{ textAlign: "left" }}>
          <h3>Hello!</h3>
          <Spacer>This is where I host side-projects.</Spacer>
          <Spacer mt="1em">For contacting me or for more info, here are some links:</Spacer>
          <Layout mt="1em" vertical>
            <small>
              <a target="_blank" href="https://github.com/Charlesthebird/">
                - GitHub
              </a>
            </small>
            <small>
              <a target="_blank" href="https://www.linkedin.com/in/nickbucher//">
                - LinkedIn
              </a>
            </small>
            <small>
              <a target="_blank" href="https://restaurantonmarsstudios.github.io/">
                - Restaurant on Mars Studios
              </a>
            </small>
          </Layout>
        </Spacer>
      </Card>
    </Spacer>
  );
};

export default Homepage;
